




































import { Component, Vue } from "vue-property-decorator";
import TsTable from "@/components/TsTable/TsTable.vue";
import { copyFn } from "@/utils/baseFn";
import { clickCopy } from "./utils";
import { dataPageList, dataPageDetail } from "@/api/tenant/dataPage";
import { cloneDeep } from "lodash";
import Add from "./components/add.vue";
import Edit from "./components/edit.vue";
import { DataRow, TableRow } from "@/types/tenant/dataPage";
import { TableHead } from "@/types/common/tableComponent";
import TsDetailTab from "@/components/TsDetailTab/index.vue";
interface Func extends Vue {
  close: () => void;
  show: (data?: {}) => void;
}
@Component({
  components: {
    TsTable,
    TsDetailTab,
    Add,
    Edit,
  },
})
export default class DataExplain extends Vue {
  drawerVisible = false;
  tableData = {
    data: [],
    currentPage: 0,
    pageSize: 20,
    total: 0,
  };
  eitType = "";
  addData: {} | null = null;
  editForm = {};
  editFormCopy = {};
  tableTitleObj = {
    title: "数据页面",
    options: {
      dropdown: false,
      arr: [
        {
          type: "add",
          name: "新增",
        },
      ],
    },
  };

  tableHead = [
    {
      type: "first",
      propName: "title",
      labelName: "链接名",
      options: {
        type: "search",
      },
    },
    {
      propName: "createByName",
      labelName: "创建人",
      options: {
        type: "search",
      },
    },
    {
      propName: "createTime",
      labelName: "创建时间",
      options: {
        type: "sort",
        optionArr: [
          {
            type: "asc",
            name: "升序",
            icon: "el-icon-top",
          },
          {
            type: "desc",
            name: "降序",
            icon: "el-icon-bottom",
          },
        ],
      },
    },
    {
      propName: "remark",
      labelName: "备注",
    },
    {
      type: "edit",
      labelName: "编辑",
      propName: "edit",
      options: {
        dropdown: false,
        arr: [
          {
            type: "copy",
            name: "复制链接",
            btnType: "text",
          },
        ],
      },
    },
  ];

  tableSelectOpt = [
    {
      type: "error",
      name: "批量删除",
      icon: "el-icon-delete",
      color: "red",
    },
    {
      type: "info",
      name: "信息",
      icon: "el-icon-info",
      color: "blue",
    },
  ];

  handleInfoDefalut = {
    title: "-",
    blockList: [
      {
        key: "创建人",
        value: "-",
      },
      {
        key: "创建时间",
        value: "-",
      },
      {
        key: "最后创建时间",
        value: "-",
      },
    ],
  };

  handleInfo = this.handleInfoDefalut

  created() {
    this.getDataPageList();
  }

  async getDataPageList(_from = {}) {
    const { currentPage, pageSize } = this.tableData;
    const form = {
      page: currentPage,
      size: pageSize,
      ..._from,
    };
    const { data } = await dataPageList(form);
    this.tableData.data = data.content;
    this.tableData.total = data.totalElements;
  }

  /**
   *   点击下拉或者按钮按钮触发
   *    type 按钮类型
   *    tableItem 如果按钮存在表格中 tableItem就是当前项
   */
  handleTableBtn(type: string, tableItem: TableRow) {
    if (type === "copy") {
      let url = "";
      if (process.env.NODE_ENV === "production") {
        url = window.origin + "/amc/economyIndex?id=" + tableItem.id;
      } else {
        url = window.origin + "/economyIndex?id=" + tableItem.id;
      }
      clickCopy(copyFn(url));
    } else if (type === "add") {
      this.drawerVisible = true;
      this.eitType = "add";
      this.addData = null;
    }
  }

  // 点击表格第一列
  handleTableFirst({ id }: DataRow) {
    this.getEdit(id);
  }

  handleEdit() {
    this.addData = this.editFormCopy
    this.eitType = 'add'
  }

  /**
   * handleFilter 过滤处理filter
   */
  handleFilter(tags: TableHead[]) {
    const form: {
      [propName: string]: string;
    } = {};
    tags.forEach((item: TableHead) => {
      switch (item.params.head.options.type) {
        case "search":
          form[item.type] = item.params.opt.value;
          break;

        case "sort":
          form.sortField = item.type;
          form.direction = item.params.opt.type;
          break;
      }
    });
    this.getDataPageList(form);
  }

  // 编辑
  async getEdit(id: string) {

    const { data } = await dataPageDetail({ id });
    const _data = cloneDeep(data);
    for (let i = 0; i < _data.economicIndicatorMap.trees.length; i++) {
      const tree = _data.economicIndicatorMap.trees[i];
      let flag = false;
      for (const k in tree.branch) {
        let flag1 = false;
        for (let j = 0; j < tree.branch[k].length; j++) {
          const _subTree = tree.branch[k][j];
          if (_subTree.selected === true) {
            flag1 = true;
            flag = true;
          }
        }
        if (!flag1) {
          delete tree.branch[k];
        }
      }
      tree.flag = flag;
    }
    this.handleInfo.title = _data.title;
    this.handleInfo.blockList[0].value = _data.createByName;
    this.handleInfo.blockList[1].value = _data.createTime;
    this.handleInfo.blockList[2].value = _data.updateTime;
    this.editForm = _data;
    this.editFormCopy = data;
    this.eitType = "edit";
    this.drawerVisible = true;
  }

  // 分页相关
  // 选择条数
  handleSizeChange(val: number) {
    this.tableData.pageSize = val;
    this.getDataPageList();
  }

  // 当前第几页
  handleCurrentChange(val: number) {
    this.tableData.currentPage = val;
    this.getDataPageList();
  }

  //   关闭
  private handleCloseDrawer(status: boolean) {
    if (status) {
      this.getDataPageList();
    }
    this.handleInfo = this.handleInfoDefalut;
    this.drawerVisible = false;
  }
}
